import { useTranslation } from 'react-i18next';
import StatsDashboard from '../components/admin/dashboard/StatsDashboard';
import AdminRecentJobsHubSection from '../components/admin/dashboard/AdminRecentJobsHubSection';
import NotificationsSection from '../components/dashboard/NotificationsSection';
import ProfileSection from '../components/admin/dashboard/ProfileSection';

export default function AdminDashboard() {
  const { t } = useTranslation('common');
  return (
    <>
      <div className="flex w-full flex-col pb-5 pt-4 md:w-2/3 md:px-1 md:pb-8 md:pr-8">
        <h1 className="hyphens-auto text-5xl font-bold">{t('breadcrumbs.dashboard')}</h1>
      </div>
      <div className="flex flex-col gap-4">
        <div className="flex-1 space-y-6">
          <StatsDashboard />
          <AdminRecentJobsHubSection />
        </div>
      </div>

      <div className="mt-4 flex flex-col justify-between gap-4 md:flex-row md:items-start">
        <div className="flex flex-col md:min-w-[300px] md:items-end md:justify-end lg:min-w-[350px]">
          <NotificationsSection />
        </div>

        <div className="min-w-0 flex-1">
          <ProfileSection />
        </div>
      </div>
    </>
  );
}
